import {Empty} from 'antd';
import {PropsWithChildren, ReactNode} from 'react';

import {Spinner} from '../../layout/spinner/spinner';
import {AlertFallback} from '../alert-fallback/alert-fallback';

type PropsType = {
    isLoading?: boolean;
    isEmpty?: boolean;
    isError?: boolean;
    // antd `Empty` image node; defaults to antd's built-in illustration when omitted.
    emptyImage?: ReactNode;
};

export function DataLoadingSwitch({
    isLoading,
    isEmpty,
    isError,
    emptyImage,
    children,
}: PropsWithChildren<PropsType>): JSX.Element | null {
    if (isEmpty) {
        return <Empty image={emptyImage} />;
    }

    if (isLoading) {
        return <Spinner />;
    }

    if (isError) {
        return <AlertFallback />;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
}
